import * as React from 'react';
const DermatiteAtopicaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path d="M100.7 103.27s-3.13 2.45 0 4.9" className="prefix__cls-2" />
    <path
      d="M84.09 117.44c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M91.68 94.27c2.25-.7 3.5-3.09 2.8-5.34s-3.09-3.5-5.34-2.8-3.5 3.09-2.8 5.33c.7 2.25 3.09 3.5 5.34 2.8ZM113.55 96.62c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M118.99 117.27c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M109.49 79.22c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11M90.29 77.04c.09-.03.14-.12.11-.21a.165.165 0 0 0-.21-.11c-.09.03-.14.12-.11.21s.12.14.21.11"
      className="prefix__cls-1"
    />
    <path
      d="M130.76 58.47c0 10.77-4.61 21.4-4.61 29.22 0 12.95 10.77 17.43 10.77 53.83M69.24 58.47c0 10.77 4.61 21.4 4.61 29.22 0 12.95-10.77 17.43-10.77 53.83"
      className="prefix__cls-2"
    />
    <path
      d="M70.78 70.78c9.75 0 23.45-4.62 29.22-4.62s19.47 4.62 29.22 4.62M64.16 124.61s18.19 4.61 35.84 4.61 35.84-4.61 35.84-4.61"
      className="prefix__cls-2"
    />
  </svg>
);
export default DermatiteAtopicaIcon;
